import { createSlice } from '@reduxjs/toolkit';

export type PopupState = {
  searchPopupShow: boolean;
  isPopupManageBookingShow: boolean;
  isPopupCheckInShow: boolean;
  showGlobalPopup: boolean;
  globalPopupBody: string;
};

const initialState: PopupState = {
  searchPopupShow: false,
  isPopupManageBookingShow: false,
  isPopupCheckInShow: false,
  showGlobalPopup: false,
  globalPopupBody: "",
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    setSearchPopupShow: (state, action) => {
      state.searchPopupShow = action.payload;
    },
    setManageBookingPopupShow: (state, action) => {
      state.isPopupManageBookingShow = action.payload;
    },
    setCheckInPopupShow: (state, action) => {
      state.isPopupCheckInShow = action.payload;
    },
    setShowGlobalPopup: (state, action) => {
      state.showGlobalPopup = action.payload;
    },
    setGlobalPopupBody: (state, action) => {
      state.globalPopupBody = action.payload;
    },
  },
});

export const {
  setSearchPopupShow,
  setManageBookingPopupShow,
  setCheckInPopupShow,
  setShowGlobalPopup,
  setGlobalPopupBody,
} = popupSlice.actions;

export default popupSlice.reducer;
